import NavMenuButton from './NavMenuButton';
import SearchButton from './SearchButton';

export default function Header() {
  return (
    <header className="fixed left-0 right-0 bg-[#d6daf0] border-b border-[#34345c] flex justify-between items-center p-3" id='header'>
      <div className="flex items-center">
        <NavMenuButton />
      </div>
      <div className="flex items-center">
        <a href="/">
          <h1 className="text-xl text-[#34345c] font-bold italic">Cippi Media</h1>
        </a>
      </div>
      <div className="flex items-center">
        <SearchButton />
      </div>
    </header>
  );
}
